import { render, staticRenderFns } from "./pledge-update-audit-item.vue?vue&type=template&id=1c4a6443"
import script from "./pledge-update-audit-item.vue?vue&type=script&lang=ts"
export * from "./pledge-update-audit-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports